import { Form } from "@redriver/cinnamon-mui";
import { getJobs } from "./actions";

const JobTypeAhead = ({ contractId, clientIds, ...props }) => (
  <Form.TypeAhead
    {...props}
    lookupAction={getJobs}
    lookupParams={{ contractId, clientIds }}
  />
);

export default JobTypeAhead;
